import * as React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '@components/molecules';
import { cn } from '@utils';

export interface CardPrimaryLayoutProps extends React.HTMLAttributes<HTMLDivElement> {
	title: string;
	isCollapsed?: boolean;
	headerButtons?: React.ReactNode;
	ariaControls?: string; //should be the  same as the collaps button
	isDisabled?: boolean;
	headerSubComponent?: React.ReactNode;
	onHeaderClick?: () => void;
	TitleComponent?: React.ReactNode;
	headerClassName?: string;
	withBorder?: boolean;
	keepContentMounted?: boolean;
}

export const CardPrimaryLayout: React.FC<CardPrimaryLayoutProps> = ({
	title,
	isCollapsed = false,
	children,
	headerButtons,
	ariaControls = '',
	'aria-label': ariaLabel = 'card',
	className,
	isDisabled = false,
	headerSubComponent,
	onHeaderClick,
	TitleComponent,
	headerClassName = '',
	withBorder,
	keepContentMounted = false,
}) => {
	return (
		<Card
			data-testid="card-primary-layout"
			id={ariaLabel}
			aria-label={ariaLabel}
			className={cn(`${isDisabled ? 'text-disabled' : 'text-primary'} ${isCollapsed ? 'pb-0' : ''}`, className)}
		>
			<CardHeader
				className={cn(
					`flex items-center justify-between gap-x-2 ${isCollapsed ? 'border-none' : ''} ${onHeaderClick ? 'cursor-pointer' : ''}`,
					headerClassName
				)}
				onClick={onHeaderClick}
			>
				<div className="grow overflow-hidden">{TitleComponent ?? <CardTitle>{title}</CardTitle>}</div>
				{headerSubComponent}
				{headerButtons}
			</CardHeader>
			{(keepContentMounted || !isCollapsed) && (
				<CardContent
					className={cn(
						'pt-4',
						withBorder && 'border border-borderPrimary p-2',
						keepContentMounted && isCollapsed && 'hidden'
					)}
					id={ariaControls}
				>
					{children}
				</CardContent>
			)}
		</Card>
	);
};
